<template>
  <div class="verification">
    <div class="verification__image--small verification__image--shared-account"></div>
    <h3 class="verification__title">{{ title }}</h3>
    <p class="verification__description">
      {{ descriptionBeforeLink }}
      <router-link :to="{name: 'BuyerEmployees'}"
                   class="verification__link">
        {{ $gettext('Employees') }}
      </router-link>
      {{ descriptionAfterLink }}
    </p>
    <button class="sk-btn sk-btn--white verification__sign-out-button"
            @click="logOut">{{ $gettext('Sign out') }}</button>
  </div>
</template>

<script>
  export default {
    computed: {
      title() { return this.$gettext('Personal account required'); },
      descriptionBeforeLink() {
        return this.$gettext('This account is shared and cannot be used for secure access. Please log out and use your personal account. You can check the');
      },
      descriptionAfterLink() {
        return this.$gettext(' page for your enterprise to see if you already have an account, or create a personal account for yourself.');
      }
    },
    methods: {
      logOut() {
        this.$store.dispatch('TTAuthStore/logOut').then(() => {
          // set cookie for preventing mobile app redirect after clicking on logout button
          this.$cookieManager.setCookie('preventMobileAppRedirect', true, {path: '/', expires: 2592000});
          setTimeout(() => {
            this.$goToExternalLoginPage();
          }, 0);
        });
      },
    }
  };
</script>
